import {AfterViewInit, Component, ElementRef, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {FilterService} from '../shared/filter.service';
import {AuthService} from '../auth/auth.service';
import {UrlStore} from '../shared/url-store';

@Component({
    selector: 'app-api-docs',
    templateUrl: './api-docs.component.html',
    styleUrls: ['./api-docs.component.scss']
})
export class ApiDocsComponent implements AfterViewInit {
    @ViewChild('swaggerContainer') swaggerContainer!: ElementRef<HTMLElement>;

    public loadError = false;

    private filterLayout = {
        screenName: 'api-docs',
        toolbarHidden: true,
        // The sidebar template dereferences journeyFilterConfig.isRequired unconditionally,
        // so it must be present even though the filter sidebar is hidden on this screen.
        journeyFilterConfig: {
            dropDownType: 'single',
            isRequired: false
        },
        hidden: []
    };

    constructor(private filterService: FilterService,
                private http: HttpClient,
                private auth: AuthService) {
        this.filterService.updateFilterLayout(this.filterLayout);
    }

    ngAfterViewInit(): void {
        this.loadSwaggerCss();
        // HttpClient so the token interceptor authenticates the request
        this.http.get(UrlStore.api.public.swaggerSpec).subscribe((spec: any) => {
            // flask-restx omits host; point "Try it out" at the API, not the UI origin
            const apiUrl = new URL(UrlStore.api.public.swaggerSpec);
            spec.host = apiUrl.host;
            spec.schemes = [apiUrl.protocol.replace(':', '')];
            this.renderSwaggerUi(spec);
        }, error => {
            console.error(`Error retrieving public API spec ${error}`);
            this.loadError = true;
        });
    }

    // Served from assets: the stylesheet's data-URIs break the Angular CSS pipeline
    private loadSwaggerCss(): void {
        if (document.getElementById('swagger-ui-css')) {
            return;
        }
        const link = document.createElement('link');
        link.id = 'swagger-ui-css';
        link.rel = 'stylesheet';
        link.href = 'assets/swagger-ui/swagger-ui.css';
        document.head.appendChild(link);
    }

    private renderSwaggerUi(spec: any): void {
        const apiOrigin = new URL(UrlStore.api.public.swaggerSpec).origin;
        // Dynamic import keeps the bundle lazy; the package root needs Node's path
        import('swagger-ui-dist/swagger-ui-bundle').then(module => {
            const SwaggerUIBundle = module.default;
            SwaggerUIBundle({
                spec,
                domNode: this.swaggerContainer.nativeElement,
                deepLinking: false,
                tryItOutEnabled: true,
                requestInterceptor: (request: any) => {
                    // swagger-ui fetches outside Angular; only send tokens to the API origin
                    if (new URL(request.url, window.location.origin).origin === apiOrigin) {
                        request.headers = request.headers || {};
                        request.headers['Authorization'] = `Bearer ${this.auth.getAccessToken()}`;
                        request.headers['IdToken'] = this.auth.getIdToken();
                    }
                    return request;
                }
            });
        });
    }
}
